import { useEffect, useState } from 'react';
import apiHelper from '../../../../api/apiHelper';
import { WagonTemplateWithRecommissioningReports } from '../wagonTemplateDetailsTypes';

export const useWagonTemplateReportsLoader = (registration: string | null) => {
  const [wagonTemplateDetails, setWagonTemplateDetails] = useState<WagonTemplateWithRecommissioningReports>();

  useEffect(() => {
    if (registration) {
      apiHelper.get(`/api/wagon-templates/${registration}`).then((result) => setWagonTemplateDetails(result));
    } else {
      setWagonTemplateDetails(undefined);
    }
  }, [registration]);

  return wagonTemplateDetails;
};
